import React from "react";
import UpdatePassword from "../../athlete/account/UpdatePassword";
import AdminPersonalInfo from "./AdminPersonalInfo";
import AdminUpdateBio from "./AdminUpdateBio";
import AdminProfilePhoto from "./AdminProfilePhoto";

function AdminAccount() {
  return (
    <>
      <div className="p-4 bg-gray-100 h-screen">
        <div className="flex flex-col xl:flex-row lg:flex-row gap-4">
          <div className="w-full lg:w-2/4 xl:w-2/4">
            <div className="hidden">
              <AdminPersonalInfo />
            </div>
            <AdminUpdateBio />
            <UpdatePassword title="Update Password" />
          </div>
          <div className="w-full lg:w-2/4 xl:w-2/4">
            <AdminProfilePhoto />
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminAccount;
